import { render, staticRenderFns } from "./BtnComprometer.vue?vue&type=template&id=2ffb969a"
import script from "./BtnComprometer.vue?vue&type=script&lang=js"
export * from "./BtnComprometer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports